module.exports = __webpack_public_path__ + "img/TSN_02.eac8852b.png";